import { render, staticRenderFns } from "./AmazonPremiumListing.vue?vue&type=template&id=da90ff94&scoped=true"
import script from "./AmazonPremiumListing.vue?vue&type=script&lang=js"
export * from "./AmazonPremiumListing.vue?vue&type=script&lang=js"
import style0 from "./AmazonPremiumListing.vue?vue&type=style&index=0&id=da90ff94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da90ff94",
  null
  
)

export default component.exports